module.exports = __webpack_public_path__ + "static/image-targets-for-homepage-a526774c2a8589b809772f1fc432734e.jpg";